import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../../../partials/aside/Sidebar";
import httpService from "../../../../../../services/httpServices/httpServices";
import helpersNumber from "../../../../../../helpers/numbers";
import helperSpinner from "../../../../../../helpers/spinner";
import helperTime from "../../../../../../helpers/time";
import StatusCampaignSimple from "../../../../campaigns/banner/StatusCampaignSimple";
import Pagination from "../../../../../partials/content/Pagination";

function AllCampaign() {
  const [campaigns, setCampaigns] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [campaignIDSearchFilter, setCampaignIDSearchFilter] = useState();

  useEffect(() => {
    getAllCampaignsBannerSimpleUsers();
  }, []);

  useEffect(() => {
    getAllCampaignsBannerSimpleUsers();
  }, [currentPage, countItemPerPage, campaignIDSearchFilter]);

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const getRequestAllCampaignsBannerSimpleUsers = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let allCampaignsBannerSimpleUsers;
    try {
      allCampaignsBannerSimpleUsers = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/campaign/manage/banner/simple/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allCampaignsBannerSimpleUsers.data.data;
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (campaignIDSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&id=${campaignIDSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const getAllCampaignsBannerSimpleUsers = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allCampaignsBannerSimpleUsers =
      await getRequestAllCampaignsBannerSimpleUsers(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (allCampaignsBannerSimpleUsers === false) {
      return;
    }

    setCampaigns(allCampaignsBannerSimpleUsers.campaigns);
    setCountPage(allCampaignsBannerSimpleUsers.count_page);
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateCampaigns = () => {
    return (
      <>
        <div className="alert alert-info">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در شماره کمپین</label>
              </div>
              <div>
                <input
                  onKeyUp={(e) => setCampaignIDSearchFilter(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                  className="form-control"
                  id="site"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>شماره کمپین</td>
                <td>شماره کاربر</td>
                <td>شماره گروه نمایش دهنده</td>
                <td>نام کمپین</td>
                <td>وضعیت</td>
                <td>تاریخ ایجاد</td>
                <td>تاریخ شروع</td>
                <td>تاریخ پایان</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {campaigns.map((campaign) => {
                return (
                  <tr index={campaign.cam_id}>
                    <td>{campaign.cam_id}</td>
                    <td>{campaign.cam_user_id}</td>
                    <td>{campaign.cam_category_id}</td>
                    <td>{campaign.cam_name}</td>
                    <td>
                      <span
                        className={`badge 
                       ${
                         campaign.cam_status ===
                         StatusCampaignSimple.statusCampaign
                           .PENDING_TO_START_DATE
                           ? "badge-warning"
                           : ""
                       } 
                       ${
                         campaign.cam_status ===
                         StatusCampaignSimple.statusCampaign.ACTIVE
                           ? "badge-success"
                           : ""
                       } 
                       ${
                         campaign.cam_status ===
                         StatusCampaignSimple.statusCampaign.CANCELED
                           ? "badge-danger"
                           : ""
                       } 
                       ${
                         campaign.cam_status ===
                         StatusCampaignSimple.statusCampaign.FINISHED
                           ? "badge-info"
                           : ""
                       } 
                    `}
                      >
                        {
                          StatusCampaignSimple.statusCampaignString()[
                            campaign.cam_status
                          ]
                        }
                      </span>
                    </td>
                    <td dir="ltr">
                      {helpersNumber.toPersianNum(campaign.cam_created_at)}
                    </td>
                    <td dir="ltr">
                      {helpersNumber.toPersianNum(
                        helperTime.convertGregorianToJalali(
                          campaign.start_date
                        ) + " 00:00"
                      )}
                    </td>
                    <td dir="ltr">
                      {helpersNumber.toPersianNum(
                        helperTime.convertGregorianToJalali(campaign.end_date) +
                          " 23:59"
                      )}
                    </td>
                    <td>
                      <Link
                        className="btn btn-info"
                        to={`/campaigns/manage/banner/simple/view/${campaign.cam_id}`}
                      >
                        <i className="fa fa-info"></i>
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 && generatePagination()}
      </>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-campaigns" activeItem="all-campaign-banner" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">همه کمپین های کاربران</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {campaigns.length == 0 && campaignIDSearchFilter == null ? (
                <></>
              ) : (
                generateCampaigns()
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllCampaign;
